import React, { Component } from "react";
import { connect } from "react-redux";
class ErrorBoundary extends Component {
    state = {
        hasError: false,
        errorInfo: null,
        error: null
    };

    static getDerivedStateFromError(error) {
        console.debug({ error });
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true,
            error: { ...error }
        };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        // You can also log the error to an error reporting service
        // logErrorToMyService(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
        // You can render any custom fallback UI

            return (
                <div>
                    <h2>Something went wrong.</h2>
                    <code>
                        {this.state.error && this.state.error.toString()}
                    </code>
                    <details style={{ whiteSpace: "pre-wrap" }}>
                        {this.state.error && this.state.error.toString()}
                        <br />
                        {this.state.errorInfo &&
                            this.state.errorInfo.componentStack}
                    </details>
                </div>
            );
        }

        return this.props.children;
    }
}

const mapStateToProps = state => ({ contact: state.contacts.contact });

export default connect(mapStateToProps)(ErrorBoundary);